<script lang="ts">
  import { app } from "../lib/store.svelte.ts";
  import { shortDateTime } from "../lib/format.ts";
  import * as T from "../settings/shared.ts";
  import { fill, shows } from "../settings/index.ts";

  const event = $derived(app.asOfSeq === null ? null : app.events.find((e) => e.seq === app.asOfSeq));
</script>

{#if app.asOfSeq !== null}
  <div class="asof" role="status">
    <div>
      {#if shows(T.ASOF_TITLE)}<strong>{T.ASOF_TITLE}</strong>{/if}
      <span>
        {#if event}{fill(T.ASOF_AT_CHANGE_TEXT, { when: shortDateTime(event.at), seq: event.seq, total: app.events.length })}{:else}{T.ASOF_BEFORE_ANY_TEXT}{/if}
        {#if shows(T.ASOF_EDITING_OFF_TEXT)}{T.ASOF_EDITING_OFF_TEXT}{/if}
      </span>
    </div>
    <button class="btn small primary" onclick={() => (app.asOfSeq = null)}>{T.ASOF_RETURN_BUTTON}</button>
  </div>
{/if}

<style>
  .asof {
    position: sticky;
    top: 0;
    z-index: 25;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px var(--gutter);
    background: var(--sel);
    border-bottom: 1px solid var(--rule-strong);
    font-size: var(--t-sm);
  }

  .asof span {
    color: var(--ink-2);
    margin-left: 6px;
  }

  @media (max-width: 860px) {
    .asof {
      top: 57px;
    }
  }
</style>
